import React from 'react';
import { Script } from 'gatsby';
import { ThemeProvider } from 'styled-components';
import Menu from '@components/layout/Menu.json';
import { InitInsights } from '@repo/utils/algoliaAnalytics';
import PageWrapper from '@repo/ui-components/page-wrapper/PageWrapper';
import Header from '@repo/ui-components/header/Header';
import Footer from '@components/footer/Footer';
import theme from '@components/theme';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'lite-youtube-embed/src/lite-yt-embed.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'petsafe/src/styles/globals.css';
import '@utils/globals.css';

InitInsights();

interface LayoutProps {
  children?: React.ReactNode;
  fullWidth?: boolean;
}

function Layout({ children, fullWidth = false }: Readonly<LayoutProps>) {
  return (
    <ThemeProvider theme={theme}>
      <Header
        menuStructure={Menu.menuSections}
        searchIndexes={['petsafe-support-pages', 'petsafe-support-articles']}
        showUtilityIcons={false}
      />
      <PageWrapper $fullWidth={fullWidth} $background="inherit" $padding="0">
        <main style={{ minHeight: '64.4vh' }}>{children}</main>
      </PageWrapper>
      <Footer />
      <Script
        async
        id="fontawesome-kit"
        src="https://kit.fontawesome.com/4dd77ed7cb.js"
      />
      <Script id="mavenoid-embed" strategy="post-hydrate">
        {`
          (function (m, a, v, e, n, o, i, d) {
            d = m.createElement(a);
            d.async = true;
            d.src =    "https://widget-hosts.mavenoid.com/custom-embedding-scripts/" + n + ".js";
            i = m.getElementsByTagName(a)[0];
            i.parentNode.insertBefore(d, i);
            v[e] = v[e] || [];
          })(document, "script", window, "mavenoid", "radio-systems-corp");
        `}
      </Script>
      {process.env.GATSBY_COOKIEPRO_SITE_ID && [
        <Script
          key="otSDKStub"
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          data-domain-script={process.env.GATSBY_COOKIEPRO_SITE_ID}
        />,
      ]}
    </ThemeProvider>
  );
}

export default Layout;
